export default {
  searchClassProStatus: '',
  searchClassProSchool: '',
  searchClassProLevel: '',
  searchClassProFacult: '',
  searchClassProUser: ''
}



// WEBPACK FOOTER //
// ./src/components/class-pros/store/state.js